import React, { useState } from 'react';
import { Send } from 'lucide-react';
import '../../styles/ContactSection.css';
import emailjs from 'emailjs-com';

const ContactSection = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    businessType: '',
    message: ''
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        "https://forms.zohopublic.in/supportfnbda1/form/fnbweb/formperma/axCIKx5TIE6bJZg-tGRzEE49pTYZZMetdFIiIg6ntuQ/records",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/zoho.forms-v1+json"
          },
          body: JSON.stringify({
            SingleLine: form.name,
            Email: form.email,
            PhoneNumber: form.phone,
            Dropdown: form.businessType,
            MultiLine: form.message
          }),
          mode: "no-cors"
        }
      );

      // Since no-cors, we assume success if no error thrown
      alert("Message sent successfully! We will contact you soon.");
      setForm({
        name: "",
        email: "",
        phone: "",
        businessType: "",
        message: ""
      });
    } catch (error) {
      console.error('Zoho Email Error:', error);
      alert('Failed to send message. Please try again.');
    }

    // emailjs.send(
    //   'service_g92lh6w',
    //   'template_ghagmon',
    //   formData,
    //   '-xn67qfCHCPXZkOHy'
    // )
    // .then(() => {
    //   alert('Message sent successfully! We will contact you soon.');
    //   setFormData({
    //     name: '',
    //     email: '',
    //     phone: '',
    //     businessType: '',
    //     message: ''
    //   });
    // })
    // .catch((error) => {
    //   console.error('EmailJS Error:', error);
    //   alert('Failed to send message. Please try again.');
    // });
  };
  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   const formData = {
  //     name,
  //     email,
  //     phone,
  //     businessType,
  //     message,
  //   };

  //   const res = await fetch("http://localhost:5000/send-email", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify(formData),
  //   });

  //   if (res.ok) {
  //     alert("Thank you! We will contact you soon.");
  //   } else {
  //     alert("Failed to send message.");
  //   }
  // };


  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        <div className="contact-content">
          <div className="contact-info">
            <h2> FNBDATALAB Works Best With Founders  Who Value:</h2>
            <ul className="contact-values">
              <li>Systems over shortcuts</li>
              <li>Visibility over guesswork</li>
              <li>Execution discipline</li>
              <li>Scalable operations</li>
              <li>Long-term profitability</li>
            </ul>
            <p className="contact-cta-text">
              If you want your business to run on structure — we should talk
            </p>
          </div>

          <div className="contact-form-wrapper">
            <h3>Book a Fit Call</h3>
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name *"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address *"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
              </div>


              <div className="form-group">
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number"
                  value={form.phone}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <select
                  name="businessType"
                  value={form.businessType}
                  onChange={handleChange}
                  required
                >
                  <option value="">Business Type *</option>
                  <option value="Independent Restaurant">Independent Restaurant

                  </option>
                  <option value="Cloud Kitchen">Cloud Kitchen</option>
                  <option value="Café/Bakery">Café/Bakery</option>
                  <option value="Bar/Nightlife">Bar/Nightlife</option>
                  <option value="Hotel F&B">Hotel F&B</option>
                  <option value="Multi-Outlet Chain">Multi-Outlet Chain</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              <div className="form-group">
                <textarea
                  name="message"
                  placeholder="Tell us about your business and challenges..."
                  rows="5"
                  value={form.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="submit-btn">
                Send Message
                <Send size={18} />
              </button>

            </form>
          </div>
        </div>
      </div>
      {/* <div className="bg-gradient">
        <div className="bg-glow"></div>
        <div className="bg-grid"></div>

        <span className="particle p1"></span>
        <span className="particle p2"></span>
        <span className="particle p3"></span>
        <span className="particle p4"></span>
        <span className="particle p5"></span>
      </div> */}
      {/* <div className="app-content"> */}
      {/* Navbar */}
      {/* Hero Section */}
      {/* Other components */}
      {/* </div> */}
    </section>
  );
};

export default ContactSection;